import React from "react";
import { useNavigate } from "react-router-dom";
import PopularBlogsSkeleton from "../../skeleton/PopularBlogsSkeleton";

const PopularBlogs = ({
  blogListingData,
  blogListingLoading,
  popularBlogsHeading,
  showSkeleton,
}) => {
  const navigate = useNavigate();

  const noImage = "/assets/images/no-image.png";

  const isStillBlogListingLoading = React.useMemo(
    () =>
      blogListingLoading ||
      !blogListingData ||
      typeof blogListingData.code === "undefined",
    [blogListingLoading, blogListingData]
  );

  const handleBlogClick = (blogId, blogSlug) => {
    navigate(`/blog-detail/${blogSlug}`, {
      state: { blogId },
    });
  };

  const popularBlogCount =
    blogListingData?.data
      ?.filter((blog) => blog.ePopular === "Yes")
      .sort((a, b) => new Date(b.dtAddedDate) - new Date(a.dtAddedDate))
      .slice(0, 3).length || 0;

  return (
    <div className="categories-card">
      <h3 className="medium-title">{popularBlogsHeading}</h3>
      {isStillBlogListingLoading || showSkeleton ? (
        <div
          className="popular-skeleton-wrapper"
          style={{ minHeight: "300px" }}
        >
          <PopularBlogsSkeleton count={popularBlogCount} />
        </div>
      ) : blogListingData &&
        blogListingData.code === 200 &&
        blogListingData.data ? (
        <div className="d-flex flex-column gap-lg-4 gap-4">
          <>
            {[...blogListingData.data]
              .filter((blog) => blog.ePopular === "Yes")
              .sort((a, b) => new Date(b.dtAddedDate) - new Date(a.dtAddedDate))
              .splice(0, 3)
              .map((popularBlog, popularBlogIndex) => (
                <div key={popularBlogIndex} className="blog-maincard">
                  <div className="blog-cardimgDiv">
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleBlogClick(popularBlog.iBlogId, popularBlog.vSlug)
                      }
                      className="blog-cardimg"
                      width={307}
                      height={200}
                      src={
                        popularBlog?.vImage &&
                        !popularBlog?.vImage?.endsWith(null)
                          ? popularBlog?.vImage
                          : noImage
                      }
                      alt={popularBlog.vImageAlt}
                    />
                    <span
                      className="blogviewdate"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleBlogClick(popularBlog.iBlogId, popularBlog.vSlug)
                      }
                    >
                      {popularBlog.dtAddedDate}
                    </span>
                  </div>
                  <div className="blogcard-content">
                    <div className="blogtype-dateDiv">
                      <span
                        className="blogclean-type"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleBlogClick(
                            popularBlog.iBlogId,
                            popularBlog.vSlug
                          )
                        }
                      >
                        {popularBlog.category.vCategory}
                      </span>
                    </div>
                    <div className="text-decoration-none">
                      <h2
                        className="medium-title"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleBlogClick(
                            popularBlog.iBlogId,
                            popularBlog.vSlug
                          )
                        }
                      >
                        {popularBlog.vBlog}
                      </h2>
                    </div>
                    <div
                      className="blog-cont"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleBlogClick(popularBlog.iBlogId, popularBlog.vSlug)
                      }
                      dangerouslySetInnerHTML={{
                        __html: popularBlog.tDescription,
                      }}
                    />
                  </div>
                </div>
              ))}
          </>
        </div>
      ) : (
        <div className="col-12">
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px 0",
            }}
          >
            No Data Found
          </p>
        </div>
      )}
    </div>
  );
};

export default PopularBlogs;
